import { render, staticRenderFns } from "./DataDashboard.vue?vue&type=template&id=0d96be1e&scoped=true"
import script from "./DataDashboard.vue?vue&type=script&lang=js"
export * from "./DataDashboard.vue?vue&type=script&lang=js"
import style0 from "./DataDashboard.vue?vue&type=style&index=0&id=0d96be1e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d96be1e",
  null
  
)

export default component.exports